module.exports = __webpack_public_path__ + "static/media/progress-right.cd506ecb.svg";